import { render, staticRenderFns } from "./ErrorMessageDisplay.vue?vue&type=template&id=53d65084&scoped=true&"
import script from "./ErrorMessageDisplay.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d65084",
  null
  
)

export default component.exports